import { camelCase } from 'lodash';
import $ from 'gridstrap/lib/gs-zepto';
import analytics from 'gridstrap/lib/gs-analytics';

export class GSProductListFilters {

	//
	// Properties
	//

	private root;
	private top;
	private filterItems;
	private sortOptions;
	private clearButton;

	get filterCount() { return this.filterItems.filter(':checked').length; }

	get sortCriteria() {
		let [ direction, property ] = this.sortOptions.val().split(':');
		return { direction, property };
	}

	get ratingFilter() { return +this.filterItems.filter(`[name="rating"]:checked`).val() || undefined; }
	get priceLevelFilter() { return this.filterItems.filter(`[name="priceLevel"]:checked`).map(function() { return +$(this).val(); }).get(); }
	get deploymentFilter() { return this.filterItems.filter(`[name="deployment"]:checked`).val(); }
	get platformsFilter() { return this.filterItems.filter(`[name="clientOS"]:checked`).map(function() { return $(this).val(); }).get(); }

	get filters() {
		return {
			rating: this.ratingFilter,
			deployment: this.deploymentFilter,
			priceLevel: this.priceLevelFilter,
			clientOS: this.platformsFilter
		};
	}

	//
	// Methods
	//

	sort() {
		let eventCategory = 'product-sort';
		let eventAction = 'change';
		let eventLabel = this.sortOptions.val();
		analytics.event({ eventCategory, eventAction, eventLabel });

		this.apply();
	}

	filter(evt) {
		// TODO: Add tracking event?
		this.apply();
	}

	apply() {

		// Sort
		let { property, direction } = this.sortCriteria;
		this.top.sort(property, direction);

		// Apply filters
		let products = this.top.products.current;
		let filtered = this.matches(products);

		// Gate null set filters
		this.gateAll(products);

		// Render new list
		this.top.isFiltering = true;
		this.top.items.scrollToTop().then(() => {
			this.top.products.current = filtered;
			this.top.isEmpty = filtered.length === 0;
			this.top.items.loadMore(true);
			this.top.isFiltering = false;
			this.clearButton.isVisible = this.filterCount > 0
		});
}

	gateAll(products) {
		this.gate({ name: 'rating',     products, map: (val) => val });
		this.gate({	name: 'deployment', products, map: (val) => val });
		this.gate({	name: 'priceLevel', products, map: (val) => ([+val]) });
		this.gate({ name: 'clientOS',   products, map: (val) => ([val]) });
	}

	gate(opts: { name, products, map }) {
		let { name, products, map } = opts;
		let options = this.filterItems.filter(`[name="${name}"]`);

		options.not(':checked').each((i, el) => {
			let option = $(el).closest('.gs-FormOption').gs(0);
			let filters = { ...this.filters, [name]: map(option.value) };
			let matches = this.matches(products, filters);
			option.disabled = matches.length === 0;
		});
	}

	matches(products, filters = this.filters) {
		let { rating, priceLevel, deployment, clientOS } = filters;
		return products
			.filter(product => !rating            || product.ratings.userScore * 5 >= rating)
			.filter(product => !priceLevel.length || priceLevel.includes(product.price.level))
			.filter(product => !deployment        || product.deployment[deployment])
			.filter(product => !clientOS.length   || clientOS.some((val) => product.clientOS[val]))
		;
	}

	clear() {
		this.filterItems.prop('checked', false);
		this.apply();
	}



	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.filterItems = this.root.find('.gs-ProductList-filterItem .gs-FormOption-input');
		this.sortOptions = this.root.find('.gs-ProductList-sortOptionsList');
	}

	gsOnInit() {
		this.top = this.root.closest('.gs-ProductList').gs(0);
		this.clearButton = this.root.find('.gs-Button[role~="clear"]').gs(0);
		this.clearButton.isVisible = false;

		this.filterItems.on('click', evt => this.filter(evt));
		this.sortOptions.on('change', () => this.sort());
		this.clearButton.root.on('click', () => this.clear());

	}

	gsOnDestroy() {
		this.filterItems.off();
		this.sortOptions.off();
	}
}
